module.exports = __webpack_public_path__ + "img/2024_04.51d710e9.jpg";